import React, {createContext, useReducer} from 'react'

export const SET_FUNCTIONAL_DIAGRAM_LIST = 'SET_FUNCTIONAL_DIAGRAM_LIST'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_FUNCTIONAL_DIAGRAM_LIST:
      return { ...data, list: payload.data }
    default:
      return data
  }
}

const initialState = {
  list: [],
}

const FunctionalDiagramStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <FunctionalDiagramContext.Provider value={[state, dispatch]}>
      {children}
    </FunctionalDiagramContext.Provider>
  )
}

export const FunctionalDiagramContext = createContext(initialState)
export default FunctionalDiagramStore
